import { Component, Injector, Input } from '@angular/core';
import * as d3 from 'd3';
import { BaseComponent } from '../../baseComponent';

@Component({
  selector: 'app-scatter',
  templateUrl: './scatter.component.html',
  styleUrls: ['./scatter.component.css']
})
export class ScatterComponent extends BaseComponent {
  @Input() Id = "2"
  private svg: any
  private margin = 50
  private width = 750 - (this.margin * 2)
  private height = 400 - (this.margin * 2)
  private fillColor = "#69b3a2"
  private xAxisTitle = "x-axis title"
  private yAxisTitle = "y-axis title"
  private opacity = 0.5

  constructor(injector: Injector) { super(injector) }

  public configure(fillColor = "#69b3a2", opacity = 0.5, xAxisTitle = "x-axis title", yAxisTitle = "y-axis title") {
    this.fillColor = fillColor
    this.xAxisTitle = xAxisTitle
    this.yAxisTitle = yAxisTitle
    this.opacity = opacity
  }

  public plot(data: any, fieldnameX: string, fieldnameY: string) {
    this.createSvg()

    data.forEach((d: any) => { d.x = d[fieldnameX]; d.y = d[fieldnameY] })
    let minmaxx = this.minmax(data, "x")
    let minmaxy = this.minmax(data, "y")

    const xScale = d3.scaleLinear()
      .domain([minmaxx.min, minmaxx.max])
      .range([0, this.width]);
    let xAx = this.svg.append("g")
      .attr("transform", "translate(0," + this.height + ")")
      .call(d3.axisBottom(xScale).tickFormat(d3.format("d")));

    xAx.append("text")
      .attr("x", this.width / 2)
      .attr("y", 30)
      .attr("fill", "black")
      .text(this.xAxisTitle);


    const yScale = d3.scaleLinear()
      .domain([minmaxy.min, minmaxy.max])
      .range([this.height, 0]);
    let yAx = this.svg.append("g")
      .call(d3.axisLeft(yScale));

    yAx.append("text")
      .attr("class", "axis-description")
      .attr("y", -40)
      .attr("x", 0 - (this.height / 2))
      .attr("dy", "1em")
      .attr("transform", "rotate(-90)")
      .style("text-anchor", "middle")
      .attr("fill", "black")
      .text(this.yAxisTitle);

    // Add dots
    const dots = this.svg.append('g');
    dots.selectAll("dot")
      .data(data)
      .enter()
      .append("circle")
      .attr("cx", (d: any) => xScale((d.x)))
      .attr("cy", (d: any) => yScale((d.y)))
      .attr("r", 7)
      .style("opacity", this.opacity)
      .style("fill", this.fillColor);
  }

  private createSvg(): void {
    d3.select("#" + this.Id).selectAll("*").remove();
    const element = d3.select("#" + this.Id)
    let t1:any = element.node()

    if (t1 != null) {
      this.width = t1.getBoundingClientRect().width - 2 * this.margin;
      this.height = this.width * 400 / 750
    }
    
    

    this.svg = d3.select("#" + this.Id)
      .append("svg")
      .attr("width", this.width + (this.margin * 2))
      .attr("height", this.height + (this.margin * 2))
      .append("g")
      .attr("transform", "translate(" + this.margin + "," + this.margin + ")");

    this.svg.append("rect")
      .attr("x", -this.margin)
      .attr("y", -this.margin)
      .attr("width", this.width + 2 * this.margin)
      .attr("height", this.height + 2 * this.margin)
      .style("fill", "white")
      .style("stroke", "gray")

    // this.svg.append("rect")
    //   .attr("x", 0)
    //   .attr("y", 0)
    //   .attr("width", this.width)
    //   .attr("height", this.height)
    //   .style("fill", "lightblue");
  }

}
